import React, { useEffect, useState } from "react";
import {
  PopupContainer,
  PopupHeader,
  TitleContainer,
  Title,
  Count,
  FeatureContainer,
  PopupBody,
  Wrapper,
  ContentWrapper,
  ContentTitle,
  PartnerLocationIcon,
  ContentTitleText,
  ContentSubTitle,
  PopupFooter,
  ViewAlllContent,
  ViewAllButtonWrapper,
  PlayButtonWrapper,
  SvgContainer,
  BookmarkIconContainer,
  ContentFlex,
  CompareIconContainer,
} from "./index.styled";

import { ReactComponent as DownloadUpIcon } from "../../Assets/Icons/DownloadUpIcon.svg";
import { ReactComponent as DownloadDownIcon } from "../../Assets/Icons/DownloadDownIcon.svg";
import { ReactComponent as BookMarkFilled } from "../../Assets/Icons/BookMarkFilled.svg";
import { ReactComponent as BookmarksUnfilledIcon } from "../../Assets/Icons/BookMarkUnFilled.svg";
import { ReactComponent as PlayButton } from "../../Assets/Icons/PlayButton.svg";
import { ReactComponent as SliderIconGray } from "../../Assets/Icons/SliderIconGray.svg";
import { ReactComponent as SelectedCompareHospital } from "../../Assets/Icons/SelectedCompareHospital.svg";
import { ReactComponent as PartnerLocation } from "../../Assets/Icons/PartnerLocation.svg";
import BookmarkSharedModal from "../BookmarkSharedModal";
import OptionsList from "../OptionsList";
import { Loader } from "../../App";
import {
  extractProviderNumbers,
  toTitleCase,
  viewSizeCalculator,
  exportTableData,
} from "../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import { useFilters } from "../../hooks/useFilters";
import Info from "../Info";
import {
  addProviderNumbers,
  setHospitalsDetails,
  setIsBookmarkTable,
} from "../../Redux/app/app.actions";
import { useRemoveBookmark } from "../../hooks/useBookmarks";
import {
  addHospitalToCompare,
  removeHospitalFromCompare,
} from "../../Redux/compare/compare.actions";
import { useDispatch, useSelector } from "react-redux";
import { views, exportOptions } from "../../Configs/config";
import { useSnack } from "../SnackBar";

const Popup = ({
  isPopupVisible,
  togglePopup,
  isDropdownOpen,
  setIsDropdownOpen,
  data,
  bookmarkList,
  bookmarksTableList = [],
  resetFlag,
  setResetFlag,
}) => {
  const { compareHospitals } = useSelector((state) => state.compare);
  const dispatch = useDispatch();
  const removeBookmark = useRemoveBookmark();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState({});
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { resetFilters } = useFilters();
  const snack = useSnack();

  const isAddedToCompare = (id) => {
    return compareHospitals.some((el) => el.provider_number === id);
  };

  const addToCompare = (data) => {
    if (compareHospitals.length >= 20) {
        snack(
          "Max Selection reached! Up to 20 Hospitals can be compared",
          "#FFC640",
          "#333333"
        );
        return;
    }

    const [state, city] = data?.address?.split(',').map(s => s.trim());

    const payload = {
      value: data["name"],
      label: toTitleCase(data["name"]),
      location:
        city && state
          ? `${city
              .toLowerCase()
              .replace(/\b\w/g, (c) => c.toUpperCase())}, ${state.toUpperCase()}`
          : "N/A",
      provider_number: data?.provider_number,
    };

    const updatedCompareCount = compareHospitals.length + 1;

    dispatch(addHospitalToCompare(payload));

    snack(
      `View all (${updatedCompareCount}) Hospital added in Compare screen!`,
      "#1F1F1F",
      "#FFFFFF",
      "View",
      () => {
        if (updatedCompareCount < 2) {
          snack(
            "Select at least two hospitals to compare!",
            "#FFC640",
            "#333333"
          );
        } else {
          togglePopup("isTableVisible");
        }
      }
    );
  };

  const removeFromCompare = (id) => {
    dispatch(removeHospitalFromCompare(id));
    snack("Hospital removed from Compare screen!");
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen((prev) => !prev);
  };

  const handleOptionClick = (option) => {
    setIsDropdownOpen(false);
    onExportLocal(option.type);
  };

  const onExportLocal = (type) => {
    exportTableData(bookmarksTableList, type, "Bookmarked Hospitals");
  };

  const removeBookmarkedItem = async (providerNumber) => {
    setLoading((prev) => ({ ...prev, [providerNumber]: true }));

    const res = await removeBookmark(providerNumber);

    if (res.success) {
      snack(
        "Bookmark removed successfully",
        "#1F1F1F",
        "#FFFFFF"
      );
    } else {
      snack(
        `Failed to remove: ${res.message}`,
        "#FFC640",
        "#333333"
      );
    }

    setLoading((prev) => ({ ...prev, [providerNumber]: false }));
  };

  const navigateToFactSheet = (provider_number) => {
    navigate(`/hospitals/${provider_number}`);
    togglePopup("isPopupVisible");
  };

  const formatAddress = (address) => {
    if (!address) return "";
    const [state, city] = address.split(", ");
    return `${city}, ${state.toUpperCase()}`;
  };

  const handleBookmarkTableView = () => {
    if (location.pathname !== "/") {
      navigate("/");
    }

    // Bookmarks show every bookmarked hospital, so any applied filters must be
    // cleared first — otherwise the table renders under a stale "filter applied"
    // query + title. resetFilters clears advanced filters, the selected state,
    // the legend selection and the search term, and switches to the table view
    // in a single navigation (also exits compare if it was open).
    resetFilters(views.TABLE);
    setResetFlag(true);

    dispatch(
      setHospitalsDetails({
        view: views.TABLE,
        filterFlag: true,
        data: bookmarksTableList,
        // Bookmarks are a complete set, so the total equals the list length.
        // Setting it here overwrites any stale count left by a previously
        // applied filter (which showed e.g. "of 835") and prevents the
        // infinite-scroll observer from firing an unnecessary reload.
        totalCount: bookmarksTableList?.length || 0,
        isBookmarkData: true,
        tableTitle: "All Bookmarks",
      }),
    );
    const providerNumbers = extractProviderNumbers(bookmarksTableList);
    dispatch(addProviderNumbers(providerNumbers));
    dispatch(setIsBookmarkTable(true));
    togglePopup("isPopupVisible");
  };

  return (
    <>
      <PopupContainer
        isPopupVisible={isPopupVisible}
        onClick={() => setIsDropdownOpen(false)}
      >
        <PopupHeader>
          <TitleContainer>
            <Title>Bookmarks</Title>
            <Count> {bookmarkList?.length || 0} </Count>
          </TitleContainer>
          <FeatureContainer>
            <Info
              showArrow={false}
              config={{
                tooltipText: "Download",
                position: "top",
              }}
            >
              <SvgContainer onClick={toggleDropdown}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                isHovered={isHovered}
              >
                <DownloadDownIcon
                  style={{
                    stroke: isHovered ? "#F96C50" : "#333333",
                  }}
                />
                <OptionsList
                  options={exportOptions}
                  onOptionClick={handleOptionClick}
                  selectedOption={exportOptions}
                  customWidth={15.75}
                  top={3}
                  showIcon={false}
                  right={true}
                  showTitle={"Export"}
                  customPadding={0.313}
                  customBorderRadius={0.625}
                  isOpen={isDropdownOpen}
                />
              </SvgContainer>
            </Info>
          </FeatureContainer>
        </PopupHeader>
        <PopupBody>
          {data &&
            data?.bookmarksList?.map((item) => (     
              <Wrapper key={item.provider_number}>
                <>
                  {loading[item.provider_number] ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Loader 
                        height={viewSizeCalculator(1.5)}
                        width={viewSizeCalculator(1.5)}
                      />
                    </div>
                  ) : (
                    <Info
                      showArrow={false}
                      config={{
                        tooltipText: "Remove Bookmark",
                        position: "top",
                        offsetY: 10,
                      }}
                    >
                      <BookmarkIconContainer
                        onClick={() =>
                          removeBookmarkedItem(item.provider_number)
                        }
                      >
                        <BookMarkFilled className="filled-svg" />
                        <BookmarksUnfilledIcon className="unfilled-svg" /> 
                      </BookmarkIconContainer>
                    </Info>
                  )}
                </>
                <ContentFlex>
                  <ContentWrapper
                    onClick={() => navigateToFactSheet(item?.provider_number)}
                  >
                    <ContentTitle>
                      {Number(item?.esa) === 1 && (
                        <PartnerLocationIcon>
                          <PartnerLocation />
                        </PartnerLocationIcon>
                      )}
                      <ContentTitleText>
                        {item?.name?.toLowerCase()}
                      </ContentTitleText>
                    </ContentTitle>
                    <ContentSubTitle>
                      {formatAddress(item?.address)}
                    </ContentSubTitle>
                  </ContentWrapper>
                  <Info
                    showArrow={false}
                    config={{
                      tooltipText: isAddedToCompare(item?.provider_number)
                        ? "Remove from Compare"
                        : "Add to Compare",
                      position: "top",
                      offsetY: 10,
                    }}
                    position="start"
                  >
                    <CompareIconContainer
                      isCompared={isAddedToCompare(item?.provider_number)}
                    >
                      {!isAddedToCompare(item?.provider_number) && (
                        <SliderIconGray onClick={() => addToCompare(item)} />
                      )}
        
                      {isAddedToCompare(item?.provider_number) && (
                        <SelectedCompareHospital
                          onClick={() => removeFromCompare(item?.provider_number)}
                        />
                      )}
                    </CompareIconContainer>
                  </Info>
                </ContentFlex>
              </Wrapper>
            ))}
          <PopupFooter>
            {data && data?.bookmarksList && (
              <ViewAllButtonWrapper onClick={handleBookmarkTableView}>
                <ViewAlllContent>View in Table</ViewAlllContent>
                <PlayButtonWrapper>
                  <PlayButton />
                </PlayButtonWrapper>
              </ViewAllButtonWrapper>
            )}
          </PopupFooter>
        </PopupBody>
      </PopupContainer>

      {isModalOpen && (
        <BookmarkSharedModal
          toggleModal={toggleModal}
          options={data && data.options}
          setIsModalOpen={setIsModalOpen}
          bookmarksList={data && data.bookmarksList}
        />
      )}
    </>
  );
};

export default Popup;
